import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'gtapp-infinite-list',
  templateUrl: './infinite-list.component.html',
  styleUrl: './infinite-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InfiniteListComponent implements OnInit {
  @Input() mobileCardBackendData: any;
  @Input() mobileCardDetails: any = [];

  @Input() otherParams: any;
  @Input() mobileActionIcons: any;
  @Input() threshold: number = 1500;

  @Output() searchColumn = new EventEmitter<any>();
  @Output() sortColumn = new EventEmitter<any>();
  @Output() loadMoreData = new EventEmitter();

  @Output() actionClick = new EventEmitter();
  @Output() rowClick = new EventEmitter();
  //pagination params

  @Input() totalRows: number = 0;

  private scrollEventListener: any;
  isLoading: boolean = false;

  constructor() {}
  ngOnInit(): void {
    this.scrollEventListener = this.onWindowScroll.bind(this);
    window.addEventListener('scroll', this.scrollEventListener);
  }

  onActionClick(event: any, type: any) {
    this.actionClick.emit({ event, type });
  }

  onRowClick(rowData: any) {
    this.rowClick.emit(rowData);
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollEventListener);
  }

  onWindowScroll(): void {
    const scrollPosition = window.innerHeight + window.scrollY;
    const maxScroll = document.body.offsetHeight - this.threshold;

    if (
      scrollPosition >= maxScroll &&
      this.mobileCardBackendData?.length < this.totalRows &&
      !this.isLoading
    ) {
      this.isLoading = true;
      this.loadMoreData.emit();

      // Reset isLoading after a timeout (e.g., after data loading is complete)
      setTimeout(() => {
        this.isLoading = false;
      }, 500); // Adjust based on your data loading time
    }
  }
}
